import React, { useState } from 'react';
import RoomItemSlider from '../RoomItemSlider/RoomItemSlider';
import RoomCapacityItem from '../RoomCapacityItem/RoomCapacityItem';
import RoomCapacityList from '../RoomCapacityList/RoomCapacityList';
import RoomItemDescr from '../RoomItemDescr/RoomItemDescr';
import RoomItemTitle from '../RoomItemTitle/RoomItemTitle';
import AmenitiesBtn from '../AmenitiesBtn/AmenitiesBtn';
import AmenitiesModal from '../AmenitiesModal/AmenitiesModal';
import styles from './RoomItemSearchResult.module.scss';
import { toggleBodyStylesForModal, formatCurrency } from '../../../helpers/helper-methods';

const RoomItemSearchResult = ({
  id,
  description,
  amenities,
  photos,
  capacitiesObj,
  surface,
  bedTypes,
  itemStyles,
  title,
  offerIndex,
  pvRate,
  offerPerPrice,
  offerTotalPrice,
  currencyCode,
  onRoomOffersClick,
  detailsView,
}) => {
  const [displayModal, setDisplayModal] = useState(false);

  const toggleModal = () => {
    toggleBodyStylesForModal();
    setDisplayModal(!displayModal);
  };

  return (
    <div className={itemStyles}>
      <div className={`${styles.mainContentWrapper} flex flex-h-start`}>
        <RoomItemSlider
          wrapperStyles={styles.sliderWrapper}
          slideStyles={styles.slideItem}
          photosArr={photos}
        />
        <div className={styles.mainInfo}>
          <div className={`${styles.subTitle} flex flex-col t-600`}>
            <RoomItemTitle containerStyles="t-600 flex flex-col">
              <span className={`${styles.titleText} text-truncate t-600`}>{title}</span>
            </RoomItemTitle>
            {!detailsView && (
              <div>
                <span className={styles.subTitleItem}>
                  Best offer:
                </span>
                <span className={`${styles.subTitlePvWrapper} ${styles.subTitleItem}`}>
                  <span className={styles.subTitleItem}>
                    #
                    {offerIndex}
                  </span>
                  <span className={styles.subTitleItem}>
                    PV:
                  </span>
                  <span className={styles.subTitleItem}>
                    {pvRate}
                  </span>
                </span>
              </div>
            )}
            <div>
              {currencyCode && offerTotalPrice ? (
                <span className={styles.subTitleItem}>
                  {formatCurrency(currencyCode, offerTotalPrice)}
                </span>
              ) : null}
              {offerPerPrice && currencyCode ? (
                <span className={styles.subTitleItem}>
                  (
                  {formatCurrency(currencyCode, offerPerPrice)}
                  /night)
                </span>
              ) : null}
            </div>
          </div>
          <RoomItemDescr containerStyles={`${styles.description} t-500`}>{description}</RoomItemDescr>
          <RoomCapacityList>
            {Object.keys(capacitiesObj).map((capacityKey, indexStep) => (
              <RoomCapacityItem
                key={`sdlkfj${indexStep}`}
                containerStyles={styles.capacityItem}
                title={capacitiesObj[capacityKey].cardLabel}
              >
                {capacitiesObj[capacityKey].values.map((capacityValues, innerIndex) => (
                  <span
                    key={`sdfd${innerIndex}`}
                  >
                    {capacityValues.value}
                    {capacityValues.prefix}
                  </span>
                ))}
              </RoomCapacityItem>
            ))}
            <RoomCapacityItem
              key="sdlkfj"
              containerStyles={styles.capacityItem}
              title="Surface:"
            >
              <span
                key="sdfd"
              >
                {surface}
                m2
              </span>
            </RoomCapacityItem>
            {amenities?.length || capacitiesObj || surface || bedTypes ? (
              <>
                <AmenitiesBtn
                  onClick={toggleModal}
                  amenitiesLength={amenities?.length}
                />
                <AmenitiesModal
                  surface={surface}
                  showModal={displayModal}
                  toggleModal={toggleModal}
                  amenities={amenities}
                  capacitiesObj={capacitiesObj}
                  bedTypesArr={bedTypes}
                />
              </>
            ) : null}
          </RoomCapacityList>
          {!detailsView && (
            <button
              type="button"
              onClick={() => onRoomOffersClick(id)}
              className={`${styles.offersBtn} ${styles.offersBtnMobile} flex-grow-1 btn btn_inverted btn-uppercased t-600`}
            >
              Room offers
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

RoomItemSearchResult.defaultProps = {
  currency: '$',
};

export default RoomItemSearchResult;
